var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMachine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.27 15.05C5.64612 15.484 5.88938 16.017 5.9707 16.5855C6.05202 17.154 5.96797 17.7338 5.72859 18.2558C5.48921 18.7778 5.10463 19.2199 4.62077 19.5291C4.13692 19.8384 3.57426 20.0019 3 20C1.34 20 0 18.66 0 17C0 15.34 1.34 14 3 14C3.18 14 3.36 14 3.53 14.05L6.6 8.69002L4.86 7.70002L8.95 6.58002L10.07 10.67L8.33 9.68002L5.27 15.05ZM19 14C17.7 14 16.6 14.84 16.18 16H10V14L7 17L10 20V18H16.18C16.6 19.16 17.7 20 19 20C20.66 20 22 18.66 22 17C22 15.34 20.66 14 19 14ZM11 6.00002C11.18 6.00002 11.36 6.00002 11.53 5.95002L14.6 11.31L12.86 12.3L16.95 13.42L18.07 9.33002L16.33 10.32L13.27 4.95002C13.6461 4.51607 13.8894 3.98303 13.9707 3.41455C14.052 2.84608 13.968 2.26621 13.7286 1.74422C13.4892 1.22223 13.1046 0.780182 12.6208 0.470888C12.1369 0.161594 11.5743 -0.00187249 11 1.61829e-05C9.34 1.61829e-05 8 1.34002 8 3.00002C8 4.66002 9.34 6.00002 11 6.00002Z",
    fill: "#467B3E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachine);
export default __webpack_public_path__ + "static/media/machine.659c8072fe150a88a595c3c627ea2578.svg";
export { ForwardRef as ReactComponent };